import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import GeneralReport from '../../components/AR/generalReport';
import { fetchGeneralReport} from '../../actions/arap_actions';

let generalReport = reduxForm({
  form: 'generalReport',
})(GeneralReport);

const selector = formValueSelector('generalReport');

function mapStateToProps(state) {
  const typeRadios = selector(state, 'typeRadios');
  const Year = selector(state, 'Year');
  const Month = selector(state, 'Month');
  const SalesType = selector(state, 'SalesType');
  const Quarter = selector(state, 'Quarter');
  return {
    typeRadios,
    Year,
    Month,
    SalesType,
    Quarter,
    generalReportIsLoading: state.arap.generalReportIsLoading,
    generalReport: state.arap.generalReport,
    generalReportError: state.arap.generalReportError,
    currentCustomer: state.customers.currentCustomer,
  };
}

export default connect(mapStateToProps, { setDefaultOfForm, fetchGeneralReport})(generalReport);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/generalReport.jsx